// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"324":"40648a2f","488":"6bd7bb57","694":"903dc625"}[chunkId] + ".chunk.js";
};